import React from 'react';
import reduxThunk from 'redux-thunk';
import { Provider } from 'react-redux';
import { createStore, applyMiddleware } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import reducers from 'reducers';
import PropTypes from 'prop-types';
import { v4 as uuidv4 } from 'uuid';

const setUUid = () => {
  const existingDeviceToken = sessionStorage.getItem('deviceToken');
  if (existingDeviceToken) {
    window.device_token = existingDeviceToken;
    return existingDeviceToken;
  }
  const uuid = uuidv4();
  sessionStorage.setItem('deviceToken', uuid);
  window.device_token = uuid;
  return uuid;
};

const environmentVariable = require('./env/env.json');

window.NHS_REDIRECT_URI = environmentVariable.nhs_redirect_uri;
window.NHS_URL = environmentVariable.nhs_url;
window.NHS_CLIENTID = environmentVariable.nhs_clientID;
window.OAUTH_CLIENTID = environmentVariable.oauth_clientID;
window.API_URL = environmentVariable.api_urls;
window.MERCHANT_ID = environmentVariable.merchant_id;
window.PROD_FEATURES = environmentVariable.prod_features;
window.CHECKOUT_PUBLIC_KEY = environmentVariable.checkout_public_key;
window.FLOODLIGHT_TRACKING_FEATURES = environmentVariable.floodlight_tracking_features;
window.FLOODLIGHT_ACCOUNT_NUMBER = environmentVariable.floodlight_account_number;
window.MANUAL_JOURNEY = environmentVariable.manual_journey;
window.GA_TAG_NUMBER = environmentVariable.ga_tag_number;

const preloadedState = {
  auth: {
    authenticated: sessionStorage.getItem('authenticated'),
    codeVerifier: sessionStorage.getItem('codeVerifier'),
    authState: sessionStorage.getItem('authState'),
    deviceToken: setUUid(),
  },
};

const composeEnhancers = composeWithDevTools({ trace: true, traceLimit: 25 });

const store = createStore(reducers, preloadedState, composeEnhancers(applyMiddleware(reduxThunk)));

const Root = ({ children }) => <Provider store={store}>{children}</Provider>;

Root.propTypes = {
  children: PropTypes.node.isRequired,
};

export default Root;
